import store from "@/store.js";
import { sha256 } from "js-sha256";
import { appModelDate, toYYMMDDHMS, encryptFun } from "@/utils/utils";
import { accessToken } from "@/utils/api";
import { Notify } from "@nutui/nutui";
const host = window.location.host;
let token = "AblTUgITSz4rl3zoWcLm1OvHvf0fv4vD";
if (host === "huituactivity.map.qq.com") token = "YK70t3hWw0KYykq9NOTWaUhsBkeKU60V"; //TODO
if (host === "huituactivitytest.map.qq.com")
  token = "AblTUgITSz4rl3zoWcLm1OvHvf0fv4vD";

const easyearn = window.easyearn

// 勿删
const publicKey =
  "-----BEGIN PUBLIC KEY-----\n" +
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCyWISToZKkMjTiuTLxpD4MpKYq\n" +
  "gk7GteG7e1cTXlekZiIelQShNvBz7xEZns3DOsJgSK1A7XYS4XAoewHFBU3r17XH\n" +
  "tFay7SV+UeANP700Sxcc8Sug0ShNFc0hpn/wGRNI3Ak6RTQaV6CUGhsKIuVIXGSR\n" +
  "YPFqTDpnPBH2MqnbxQIDAQAB\n" +
  "-----END PUBLIC KEY-----";

export default function fetchApi(method, url, data) {
  // bool 匹配需要token不要openid的url
  const urlMap = ['mizar', 'lotteries', 'address', '/activity/']
  let bool = false;
  const arr = urlMap.filter(item => url.includes(item))
  bool = arr.length > 0 ? true : false
  // 判断是否是  mizar/integration/task/conf/list  这个api不能删除openId
  const IsTokenApi = url.includes("access_token");
  // console.log(IsTokenApi, 'IsTokenApi');
  const IsCos = url.includes("getCos") && !url.includes('getCosCredentialsByScene');
  const date = Date.parse(appModelDate(toYYMMDDHMS(new Date()))) / 1000;
  let obj = {};
  let getToken = false;

  const getHeaderInfo = () => {
    const headerInfo = {
      "x-requested-with": "fetch",
      Pragma: "no-cache",
      
      Accept: "application/json",
      credentials: "include", // cookie设置
      mode: "cors", // 跨域
      "Content-Type": "application/json;charset=UTF-8",
      Openid: store.getters.huituOpenid || "",
      Timestamp: date,
      Signature: sha256(
        `${date},${token},${store.getters.huituOpenid || ""},${""},${date}`
      ).toUpperCase(),
      versioncode: store.getters.versioncode || "",
      version: store.getters.versioncode || "",
    };
    if (headerInfo["versioncode"] == "") {
      delete headerInfo["versioncode"];
    }
    // console.log(bool, !IsCos, !store.getters.haveOpenId);
    if (bool && !IsCos && !store.getters.haveOpenId) {
      if(!url.includes('mizar/integration/task/conf/list')){
        delete headerInfo["Openid"];
        delete headerInfo["Signature"];
      }
      if (!IsTokenApi) {
        headerInfo.Authorization = "Bearer " + store.getters.accessToken || "";
      }
    }
    // headerInfo.versioncode = 32102007;
    // headerInfo.Authorization = 'Bearer f3581a6369534e06b1577a77a1530d30';
    return headerInfo;
  };

  const handleTokenExpired = () => {
    if (!getToken) {
      obj = {
        method,
        url,
        data,
      };
    }
    getToken = true;
    const encryptBody = {
      appid: "csig", // 分配的应用id
      app_secret: "csig", // 分配的应用密钥
      grant_type: "refresh_token", // 固定值，refresh_token
      refresh_token: store.getters.refreshToken || "", // 刷新令牌
    };
    const ciphertext = encryptFun(JSON.stringify(encryptBody), publicKey);
    return fetchApi("post", accessToken, {
      // 加密数据
      ciphertext,
    }).then((res) => {
      return handleSuccessResponse(res)
    });
  };

  const handleTokenInvalid = (code) => {
    easyearn && easyearn.updateToken
      ? easyearn.updateToken(null, null, code)
      : "";
  };

  const handleSuccessResponse = (res) => {
    // 处理令牌
    if (res.data && (res.data.refresh_token || res.data.access_token)) {
      store.dispatch("setAccessToken", res.data.access_token);
      store.dispatch("setRefreshToken", res.data.refresh_token);
      easyearn && easyearn.updateToken
        ? easyearn.updateToken(
          res.data.access_token,
          res.data.refresh_token,
          0
        )
        : "";
    }
    // console.log(getToken,'getToken');
    // 处理业务逻辑
    if (getToken) {
      getToken = false;
      return fetchApi(obj.method, obj.url, obj.data);
    } else {
      return Promise.resolve(res);
    }
  };

  const handleError = (err) => {
    console.log(err, "err");
    return Promise.reject(err)
  };

  const requestOptions = {
    method,
    headers: getHeaderInfo(),
    cache: "no-cache",
    body: data ? JSON.stringify(data) : null,
  };

  return fetch(url, requestOptions)
    .then((response) => response.json())
    .then((res) => {
      // 处理错误码
      switch (Number(res.code)) {
        case 200001: // 访问令牌过期
          return handleTokenExpired();
          // break;
        case 200002: // 刷新令牌过期
        case 200003: // 无效的访问令牌
        case 200004: // 无效的刷新令牌
          handleTokenInvalid(Number(res.code));
          break;
        case 200005: // 非法请求
          Notify.danger("非法请求");
          break;
        default:
          return handleSuccessResponse(res);
      }
    })
    .catch(handleError);
}